<template>
  <div>
    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
              :clearable="false"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="客户：">
            <el-select filterable v-model="searchForm.customerName" placeholder="请选择" :clearable="true">
              <el-option v-for="item in customer" :key="item.TC_ID" :label="item.NAME" :value="item.TC_ID"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable>
              <el-option v-for="item in projects" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="queryTable">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain @click="exportExcel">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="importVisible = true">导入</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="margin-top: 20px">
          <el-table-column type="index" label="序号" min-width="60px"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户名称"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="70px"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="产品单位" min-width="60px"></el-table-column>
          <el-table-column prop="BRAND" label="品牌"></el-table-column>
          <el-table-column prop="SPECIFICATION" label="规格"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="产品备注"></el-table-column>
          <el-table-column prop="FCD_COMMENT" label="分菜备注"></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="上传要修改的分菜单备注" center :visible.sync="importVisible" width="600px">
      <el-form ref="addForm" v-model="addForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess" :on-remove="handleRemove"
          :name="this.addForm.price" multiple accept=".xls, .xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb，模板为导出文件<br>表格内请只写入需要修改的数据，以免耗费大量不必要的时间</div>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="importVisible = false">取 消</el-button>
        <el-button size="small" @click="importExcel">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  haveXMDFun,
} from 'api/sellOrder';
import http from '@/assets/common/http';
import date from '../../assets/common/date';

export default {
  data() {
    return {
      searchForm: { date: this.$route.params.date },
      customer: [],
      projects: [],
      tableData: [],
      currentPage: 1,
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      importVisible: false,
      addForm: {
        price: 'tmp',
      },
      fileList: [],
      file_name: '',
    };
  },
  mounted() {
    this.queryTable();
    this.queryProjects();
  },
  methods: {
    queryTable() {
      const params = {
        SERVICE_ID: '10042',
        OTYPE: 28,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        SEND_DAY: this.searchForm.date,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      http.post(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 导出
    exportExcel() {
      const params = {
        SERVICE_ID: '10042',
        OTYPE: 29,
        SEND_DAY: date(this.searchForm.date, '%F'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      http.post(params)
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          this.$message.show({ text: '导出成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 导入
    importExcel() {
      if (!this.file_name) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10042',
        OTYPE: 30,
        FILE_NAME: this.file_name,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '导入成功', type: 'success' });
        this.queryTable();
        this.importVisible = false;
        this.file_name = '';
        this.fileList = [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.file_name = '';
        this.fileList = [];
      });
    },
    // 获取项目点信息列表
    queryProjects() {
      haveXMDFun()
        .then((result) => {
          this.projects = result.length > 0 ? result[0].project : [];
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    handleChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/separateRemarks.vue